// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__N6xqX","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__1E3Ni"};